import { writable, derived } from "svelte/store";
export var AppType;
(function (AppType) {
    AppType["EXTENSION"] = "EXTENSION";
    AppType["HIGHLIGHTER"] = "HIGHLIGHTER";
    AppType["DASHBOARD"] = "DASHBOARD";
    AppType["PLUGIN"] = "PLUGIN";
})(AppType || (AppType = {}));
export var Panels;
(function (Panels) {
    Panels["NONE"] = "NONE";
    Panels["WORKSPACE"] = "WORKSPACE";
    Panels["SETTINGS"] = "SETTINGS";
    Panels["INVITATION"] = "INVITATION";
    Panels["CLUSTER"] = "CLUSTER";
    Panels["SNIPPET"] = "SNIPPET";
    Panels["SIDEPANEL"] = "SIDEPANEL";
    Panels["SHARE"] = "SHARE";
    Panels["ACTIVITY"] = "ACTIVITY";
    Panels["USER_SETTINGS"] = "USER_SETTINGS";
    Panels["SNIPPET_ARCHIVE"] = "SNIPPET_ARCHIVE";
})(Panels || (Panels = {}));
class App {
    constructor() {
        this.type = AppType.EXTENSION;
        this.panel = Panels.NONE;
        this.sidebar = {
            itemIsDragging: false,
        };
        this.focused = {
            topicId: null,
            snippetId: null,
            commentId: null,
        };
        this.snippetIsDragging = false;
        this.lemonSqueezy = {
            isLoaded: false,
        };
        this.sentry = {
            isLoaded: false,
        };
        this.pdf = {
            showOnMobile: false,
            pageNumber: null,
        };
        this.paddle = {
            isLoaded: false,
        };
    }
}
const store = () => {
    const { subscribe, set, update } = writable(new App());
    return {
        subscribe,
        set,
        update,
        setType: (type) => update((app) => {
            app.type = type;
            return app;
        }),
        closePanels: () => update((app) => {
            app.panel = Panels.NONE;
            return app;
        }),
        togglePanel: (panel) => update((app) => {
            if (app.panel !== panel) {
                app.panel = panel;
            }
            else {
                app.panel = Panels.NONE;
            }
            return app;
        }),
        setFocused: (focused) => update((app) => {
            var _a, _b, _c;
            app.focused = {
                topicId: (_a = focused === null || focused === void 0 ? void 0 : focused.topicId) !== null && _a !== void 0 ? _a : null,
                snippetId: (_b = focused === null || focused === void 0 ? void 0 : focused.snippetId) !== null && _b !== void 0 ? _b : null,
                commentId: (_c = focused === null || focused === void 0 ? void 0 : focused.commentId) !== null && _c !== void 0 ? _c : null,
            };
            return app;
        }),
        setPanel: (panel) => update((app) => {
            app.panel = panel;
            return app;
        }),
    };
};
export const AppStore = store();
export const focusedTopicId = derived(AppStore, ($app) => $app.focused.topicId);
export const focusedSnippetId = derived(AppStore, ($app) => $app.focused.snippetId);
export const focusedCommentId = derived(AppStore, ($app) => $app.focused.commentId);
